var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(data,index){return _c('li',{key:index},[_c('router-link',{attrs:{"to":data.url}},[_vm._v(_vm._s(data.name))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }